import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p>Last updated: May 5, 2025</p>

        <section>
          <h2>1. Introduction</h2>
          <p>Project Power By CW ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.</p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We collect information that you provide directly to us through our contact form, including:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Message content</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Respond to your inquiries</li>
            <li>Provide customer support</li>
            <li>Improve our services</li>
            <li>Communicate with you about our services</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.</p>
        </section>

        <section>
          <h2>5. Third-Party Services</h2>
          <p>We use the following third-party services:</p>
          <ul>
            <li>Web3Forms for contact form submissions</li>
            <li>Google Cloud Platform for hosting</li>
          </ul>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Request correction of your information</li>
            <li>Request deletion of your information</li>
            <li>Opt-out of communications</li>
          </ul>
        </section>

        <section>
          <h2>7. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p>Email: sales@projectpowerbycw.com</p>
          <p>Phone: +60 16-286 5881</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 